/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}      from '@/models/action';
import {Logger}                  from '@/util/logger';
import {WindowService}         from "@/services/window.service";
import {ScenarioBrowserMetadata} from '@/screens/ide/scenario.browser.metadata';

/**
 *
 * @class ScenarioBrowseAction
 *
 * @brief launch a new / blank scenario browser (tables view of scenario)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class ScenarioBrowseAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.scenariobrowser',
      type:  ActionType.Window_ScenarioBrowser,
      label: 'Scenario Browser (Empty)',
      icon:  '<i class="fas fa-table"></i>',
      tip:   'Launch a scenario browser'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[ScenarioBrowseAction] executing...');

    this.windows.launchWindow(new ScenarioBrowserMetadata(
      '',
      '',
      ''
    ));

    return true;
  }
}
